<div class="backgroundMask text-center">
    <div class="h2">Logging out of PAWS ... </div>
    <div class="mtlg h5">Please wait.</div>
    <p>If you are not automatically taken to cas, click <a href='{{ casLogoutUrl }}'>here</a></p>
</div>
